/**
 * [File :: B_ShapeHeader.js]
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
let mix = (superclass) => new MixinBuilder(superclass);

import B_Define from 'canvas/base/dev/util/B_Define';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_Text from 'canvas/base/dev/child/text/B_Text';
import B_Sprite from 'canvas/base/dev/child/sprite/B_Sprite';

const B_ShapeHeader = (function(superclass) {

	const HEADER_TEXT = class extends mix(B_Real).with(B_Text) { constructor(obj) { super(obj); } };
	const HEADER_IMAGE = class extends mix(B_Real).with(B_Sprite) { constructor(obj) { super(obj); } };

	class B_ShapeHeader extends superclass {

		constructor(inputJson) { super(inputJson); }

        // [F] protected

		/**
		 * [Function :: _fitShape]
		 *
		 * @DES :: 외곽 형태 만들기
		 * @IP1 :: WIDTH {num}
		 * @IP2 :: HEIGHT {num}
		 * @IP3 :: HEIGHT {num}
		 * @O.P :: null
		 * @S.E ::
		 */
		_fitShape(sWidth, sHeight, COLOR) {
			this._object.graphics.clear()
				.beginFill(COLOR)
				.drawRoundRect( /*[#] x, y ,w, h, r*/ -(sWidth / 2), -(sHeight / 2), sWidth, sHeight, sHeight / 2 );
		}

		/**
		 * [Function :: _getText]
		 *
		 * @DES :: 텍스트 설정하기
		 * @IP1 :: sWidth {num}
		 * @IP2 :: sHeight {num}
		 * @IP3 :: fontSize {num}
		 * @IP4 :: text {str}
		 * @O.P :: objText {obj}
		 * @S.E ::
		 */
		_getText(sWidth, sHeight, fontSize, text) {
			const X = (sWidth - sHeight / 2) / 4 ;
			const objText = new HEADER_TEXT({
				cm : this.CODMOS,
				id : B_Define.TIMER_TEXT_ID,
				type : B_Define.TOOL_TYPE,
				color: B_Define.TOOL_TEXT_COLOR,
				size: fontSize,
				text: text,
				x : X,
				w : B_Define.SCORE_ICON_WIDTH,
				h : B_Define.SCORE_ICON_HEIGHT,
			});
			objText._setArea();
			objText._setPoint(50, 50);
			this._container.addChild(objText._container);
			return objText;
		}

		/**
		 * [Function :: _getIcon]
		 *
		 * @DES :: 그림 설정하기
		 * @IP1 :: sWidth {num}
		 * @IP2 :: sHeight {num}
		 * @IP3 :: iWidth {num}
		 * @IP4 :: iHeight {num}
		 * @IP5 :: resource {str}
		 * @O.P ::
		 * @S.E ::
		 */
		_getIcon( sWidth, sHeight, iWidth, iHeight, resource ) {
			const X = (sWidth - sHeight) / 4;
			const objIcon = new HEADER_IMAGE({
				cm : this.CODMOS,
				id : B_Define.TIMER_ICON_ID,
				type : B_Define.TOOL_TYPE,
				res : resource,
				x : - X,
				w : iWidth,
				h : iHeight,
			});
			objIcon._setArea();
			objIcon._setPoint(50, 50);
			this._container.addChild(objIcon._container);
			return objIcon;
		}

	}

	return B_ShapeHeader;
});

export default B_ShapeHeader;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/shape/B_ShapeHeader.js